module.exports = __webpack_public_path__ + "img/LDSJ_STILL14.37fc180d.jpg";